import React from 'react';
import Cliser from 'cliser';
import Config from 'config';
import { Button, Input } from 'react-bootstrap';
import { Notification } from 'react-notification';
require('style/app.scss');
import { Router, browserHistory, Link} from 'react-router'


export default class LoginView extends React.Component {


  constructor(props) {
    super(props);
    this.state = {
      // login: {}
    };
  }


  _errorLabelDismiss() {
    this.setState({error: null})
  }

  componentWillMount() {
    this.state = {
      login: {},
      error: null
    };
    if (this.props.routeParams.token) {
      let redirect = window.location.href.match(/.*?\?.*?redirect=([^&]+)/);
    } else if (this.props.location.pathname === '/login/callback/') {
      console.log('unauthorized google login');
    }
  }

  componentWillReceiveProps(props) {
    if (props.user) {
      setTimeout(() => this.context.router.replace('/'));
    }
  }

  login() {
      // Login
    Cliser.LoginModel.login(this.refs.email.getValue(), this.refs.username.getValue())
    .then(Cliser.LoginModel.getState)
    .then((res) => {
      if (!res.token) {
        this.setState({error: "Login Failed"});
        throw new Error("Authentication Failed");
      }
      window.localStorage.setItem("token", res.token);
    })
    .then(() => {
      this.context.router.push("/047571");
    })
    .catch(err => console.log(err))
  }

  render() {

    let error = (
      <Notification
        isActive={!!this.state.error}
        message={this.state.error || ''}
        action="ok"
        dismissAfter={4000}
        onClick={this._errorLabelDismiss.bind(this)}
        onDismiss={this._errorLabelDismiss.bind(this)}/>
    );

    // whether Google login is supported or not
    let googleLogin = true;
    let googleLoginButton = googleLogin ? (
      <div className="center">
      <button style={{height: '50px', marginTop:'40px'}} className="button raised google-btn" onClick={() => {console.log("click"); window.location.href = Config.servers.api + "/auth/google"}}>
        <i className="mdi mdi-google-plus" style={{marginRight: '10px'}}/>
        Google Login
      </button>

      <div className="or-spacer">
        <div className="mask"></div>
        <span><i>or</i></span>
      </div>
      </div>
    ) : null;

    return (

        <div className="login">
          {error}
          <div className="row">
            <div className="login-box center">
                <div className="center" style={{color:'black', marginTop:'10px', fontSize: '24px'}}>
                Flowone Device Configurator</div>
              {googleLoginButton}
              <br/>
              <form onSubmit={e => {e.preventDefault(); this.login();}}>
                <Input
                  ref="email"
                  placeholder="Email"
                  type="email"
                  name="username"/>

                <Input
                  ref="username"
                  placeholder="Password"
                  type="password"
                  name="username"/>

                <Button type="submit" bsStyle="primary"  bsSize="large" block>Login</Button>
              </form>
              <div style={{color:'#696969', marginTop:'10px'}} className="center">&copy; Envera 2018</div>
            </div>
          </div>
        </div>

    );
  }
}


LoginView.propTypes = {
  error: React.PropTypes.string
}

LoginView.contextTypes = {
  router: React.PropTypes.object
}



// WEBPACK FOOTER //
// ./client/views/LoginView.js